
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';
import { usePayment } from '@/context/PaymentContext';

const CouponSection = () => {
  const {
    couponCode,
    setCouponCode,
    isApplyingCoupon,
    isProcessing,
    handleApplyCoupon,
    discount
  } = usePayment();

  return (
    <div className="space-y-2">
      <Label htmlFor="couponCode">Coupon Code</Label>
      <div className="flex gap-2">
        <Input 
          id="couponCode" 
          value={couponCode}
          onChange={(e) => setCouponCode(e.target.value)}
          placeholder="Enter coupon code" 
          disabled={isApplyingCoupon || isProcessing}
          className="flex-1"
        />
        <Button 
          onClick={handleApplyCoupon} 
          type="button" 
          variant="outline"
          disabled={isApplyingCoupon || isProcessing}
        >
          {isApplyingCoupon ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Applying...
            </>
          ) : 'Apply'}
        </Button>
      </div>
      
      {discount > 0 && (
        <div className="flex justify-between items-center text-green-600">
          <span>Discount:</span>
          <span>-₹{discount}</span>
        </div>
      )}
    </div>
  );
};

export default CouponSection;
